import { axios_requer } from '../axios/http_axios'


// 参数有这些,需要的就填,不写就用默认值

// path,
// params = {},
// method = 'POST',  //  POST / GET
// headerType = '',  //   json 和 "" 两种
// isShowLoading = true,  //是否显示加载中
// istips = true,        //是否弹窗
// hasSing = false,      //是否有签名
let hasSing = true //需要签名的加上这个
let method = 'GET' //需要GET请求的加上这个
let headerType = 'json' //需要GET请求的加上这个

export default {
    // 获取多个文件路径
    async getFileUrlMore(params) {
        return await axios_requer({
            path: "/base/saas/v1/file/getFileUrlMore",
            params,
        }).then(res => res);
    },
    // 获取行政区
    async DistrictDownList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/district/getDistrictDownList",
            params,
            method
        }).then(res => res);
    },
    // 车辆管理
    // 车辆档案--列表
    async CarArchiveList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/getCarList",
            params,
            method
        }).then(res => res);
    },
    async CarDownList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/getCarDownList",
            params,
            method
        }).then(res => res);
    },
    // 车辆档案--删除
    async delCar(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/delCar",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 车辆档案--启用
    async startCar(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/startCar",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 车辆档案--禁用
    async stopCar(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/stopCar",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 车辆档案--新建
    async addCar(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/addCar",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 车辆档案--修改
    async udpateCar(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/udpateCar",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 司机档案
    // 司机档案--列表
    async getDriverList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/driver/getDriverList",
            params,
            method
        }).then(res => res);
    },
    // 司机档案--删除
    async delDriver(params) {
        return await axios_requer({
            path: "/admin/v3/tms/driver/delDriver",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 司机档案--启用
    async startDriver(params) {
        return await axios_requer({
            path: "/admin/v3/tms/driver/startDriver",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 司机档案--禁用
    async stopDriver(params) {
        return await axios_requer({
            path: "/admin/v3/tms/driver/stopDriver",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 司机档案--新建
    async addDriver(params) {
        return await axios_requer({
            path: "/admin/v3/tms/driver/addDriver",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 司机档案--修改
    async udpateDriver(params) {
        return await axios_requer({
            path: "/admin/v3/tms/driver/udpateDriver",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 司机档案--获取司机下拉列表
    async DriverDownList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/driver/getDriverDownList",
            params,
            method
        }).then(res => res);
    },

    // 车辆成本申请-列表(共用其他支出列表)
    async OtherOutList(params) {
        return await axios_requer({
            path: "/admin/v3/finance/other/getOtherOutList",
            params,
            method
        }).then(res => res);
    },

    // 车辆成本申请-删除
    async delCarCost(params) {
        return await axios_requer({
            path: "/admin/v3/finance/other/delCarCost",
            params,
            headerType,
            hasSing,
        }).then(res => res);
    },

    // 车辆成本申请-新建
    async addCarCost(params) {
        return await axios_requer({
            path: "/admin/v3/finance/other/addCarCost",
            params,
            headerType,
            hasSing,
        }).then(res => res);
    },
    // 车辆成本申请-车辆成本过账
    async postingCarCost(params) {
        return await axios_requer({
            path: "/admin/v3/finance/other/postingCarCost",
            params,
            headerType,
            hasSing,
        }).then(res => res);
    },

    // 车辆成本申请-修改
    async updateCarCost(params) {
        return await axios_requer({
            path: "/admin/v3/finance/other/updateCarCost",
            params,
            headerType,
            hasSing,
        }).then(res => res);
    },
    // 车辆成本申请-反过账其他支出(车辆成本列表,过账,返过账使用其他支出列表)
    async unPostingOtherOut(params) {
        return await axios_requer({
            path: "/admin/v3/finance/other/unPostingOtherOut",
            params,
            headerType,
            hasSing,
        }).then(res => res);
    },

    // 财务管理-获取其他收入列表
    async OtherInList(params) {
        return await axios_requer({
            path: "/admin/v3/finance/other/getOtherInList",
            params,
            method
        }).then(res => res);
    },
    // 财务管理-获取其他收入详情
    async OtherInDetail(params) {
        return await axios_requer({
            path: "/admin/v3/finance/other/getOtherInDetail",
            params,
            method
        }).then(res => res);
    },
    // 财务管理-获取其他收入的运单信息
    async OtherInWaybillList(params) {
        return await axios_requer({
            path: "/admin/v3/finance/other/getOtherInWaybillList",
            params,
            method
        }).then(res => res);
    },
    // 财务管理-根据运单号获取运单信息
    async WaybillListByNumber(params) {
        return await axios_requer({
            path: "/admin/v3/finance/other/getWaybillListByNumber",
            params,
            headerType,
        }).then(res => res);
    },
    // 财务管理-新建其他收入
    async addOtherIn(params) {
        return await axios_requer({
            path: "/admin/v3/finance/other/addOtherIn",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务管理-修改其他收入
    async updateOtherIn(params) {
        return await axios_requer({
            path: "/admin/v3/finance/other/updateOtherIn",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务管理-反过账其他收入
    async unPostingOtherIn(params) {
        return await axios_requer({
            path: "/admin/v3/finance/other/unPostingOtherIn",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务管理-获取其他支出列表
    async OtherOutList(params) {
        return await axios_requer({
            path: "/admin/v3/finance/other/getOtherOutList",
            params,
            method
        }).then(res => res);
    },
    // 财务管理-获取其他支出详情
    async OtherOutDetail(params) {
        return await axios_requer({
            path: "/admin/v3/finance/other/getOtherOutDetail",
            params,
            method
        }).then(res => res);
    },
    // 财务管理-获取其他支出的运单信息
    async OtherOutWaybillList(params) {
        return await axios_requer({
            path: "/admin/v3/finance/other/getOtherOutWaybillList",
            params,
            method
        }).then(res => res);
    },
    // 财务管理-反过账其他支出
    async unPostingOtherOut(params) {
        return await axios_requer({
            path: "/admin/v3/finance/other/unPostingOtherOut",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务管理-新建其他支出
    async addOtherOut(params) {
        return await axios_requer({
            path: "/admin/v3/finance/other/addOtherOut",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务管理-修改其他支出
    async updateOtherOut(params) {
        return await axios_requer({
            path: "/admin/v3/finance/other/updateOtherOut",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务报表-车辆成本报表
    async CarProfitList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/report/getCarProfitList",
            params,
            method
        }).then(res => res);
    },
    // 财务报表-客户损益表
    async CustomerOrderProfitList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/report/getCustomerOrderProfitList",
            params,
            method
        }).then(res => res);
    },
    // 财务报表-运单损益表
    async WaybillProfitList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/report/getWaybillProfitList",
            params,
            method
        }).then(res => res);
    },
    // 财务报表-部门损益表
    async DeptProfitList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/report/getDeptProfitList",
            params,
            method
        }).then(res => res);
    },
    // 财务报表-司机押运费用损益表
    async DriverProfitList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/report/getDriverProfitList",
            params,
            method
        }).then(res => res);
    },
    // 财务报表-装卸员装卸费用清单
    async HandelOrderProfitList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/report/getHandelOrderProfitList",
            params,
            method
        }).then(res => res);
    },
    // 财务报表-运单车费摊分清单
    async WaybillCarFeeProfitList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/report/getWaybillCarFeeProfitList",
            params,
            method
        }).then(res => res);
    },
    // 财务报表-应收账款明细
    async FinanceInProfitList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/report/getFinanceInProfitList",
            params,
            method
        }).then(res => res);
    },
    // 财务报表-外发应付账款明细
    async OutgoingBillProfitList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/report/getOutgoingBillProfitList",
            params,
            method
        }).then(res => res);
    },
    // 财务报表-外请应付账款明细
    async DispatchProfitList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/report/getDispatchProfitList",
            params,
            method
        }).then(res => res);
    },
    // 财务报表-车辆配载
    async CarLoadProfitList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/report/getCarLoadProfitList",
            params,
            method
        }).then(res => res);
    },
    // 油卡档案
    // 油卡档案-列表
    async OilCardList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/oil/OilCardd/getOilCardList",
            params,
            method
        }).then(res => res);
    },
    // 油卡档案-获取油卡下拉列表
    async OilCardDownList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/oil/OilCardd/getOilCardDownList",
            params,
            method
        }).then(res => res);
    },
    // 油卡档案-删除
    async delOilCard(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/oil/OilCardd/delOilCard",
            params,
            headerType,
            hasSing,
        }).then(res => res);
    },
    // 油卡档案-启用
    async startOilCard(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/oil/OilCardd/startOilCard",
            params,
            headerType,
            hasSing,
        }).then(res => res);
    },
    // 油卡档案-启用
    async stopOilCard(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/oil/OilCardd/stopOilCard",
            params,
            headerType,
            hasSing,
        }).then(res => res);
    },
    // 油卡档案-修改
    async udpateOilCard(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/oil/OilCardd/udpateOilCard",
            params,
            hasSing,
        }).then(res => res);
    },
    // 油卡档案-新建
    async addOilCard(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/oil/OilCardd/addOilCard",
            params,
            hasSing,
        }).then(res => res);
    },
    // 油卡申领记录-列表
    async OilCardApplyRecordList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/oil/OilCardd/getOilCardApplyRecordList",
            params,
            method
        }).then(res => res);
    },
    // 油卡申领记录-新建油卡申领记录
    async addOilCardApplyRecord(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/oil/OilCardd/addOilCardApplyRecord",
            params,
            hasSing
        }).then(res => res);
    },
    // 油卡充值
    // 油卡充值-列表
    async OliRechargeList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/oil/recharge/getOliRechargeList",
            params,
            method
        }).then(res => res);
    },
    // 油卡充值-删除
    async delOliRecharge(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/oil/recharge/delOliRecharge",
            params,
            headerType,
            hasSing,
        }).then(res => res);
    },
    // 油卡充值-审核
    async examineOliRecharge(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/oil/recharge/examineOliRecharge",
            params,
            headerType,
            hasSing,
        }).then(res => res);
    },
    // 油卡充值-返审核
    async reExamineOliRecharge(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/oil/recharge/reExamineOliRecharge",
            params,
            headerType,
            hasSing,
        }).then(res => res);
    },
    // 油卡充值-新建
    async addOliRecharge(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/oil/recharge/addOliRecharge",
            params,
            hasSing,
        }).then(res => res);
    },
    // 油卡充值-修改
    async udpateOliRecharge(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/oil/recharge/udpateOliRecharge",
            params,
            hasSing,
        }).then(res => res);
    },
    // 油卡流水账列表
    async OilCardFundflowList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/oil/fundflow/getOilCardFundflowList",
            params,
            method
        }).then(res => res);
    },
    // 加油记录
    // 加油记录-列表
    async OilRecordList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/oil/record/getOilRecordList",
            params,
            method
        }).then(res => res);
    },
    // 加油记录-删除
    async delOilRecord(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/oil/record/delOilRecord",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 加油记录-审核
    async examineOilRecord(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/oil/record/examineOilRecord",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 加油记录-返审核
    async reExamineOilRecord(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/oil/record/reExamineOilRecord",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 加油记录-新建
    async addOilRecord(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/oil/record/addOilRecord",
            params,
            hasSing,
        }).then(res => res);
    },
    // 加油记录-修改
    async udpateOilRecord(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/oil/record/udpateOilRecord",
            params,
            hasSing,
        }).then(res => res);
    },
    // 客商系统-承运商档案
    // 承运商档案-列表
    async CarrierList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/carrier/getCarrierList",
            params,
            method
        }).then(res => res);
    },
    // 承运商档案-新建承运商
    async addCarrier(params) {
        return await axios_requer({
            path: "/admin/v3/tms/carrier/addCarrier",
            params,
            hasSing,
        }).then(res => res);
    },
    // 承运商档案-修改承运商
    async udpateCarrier(params) {
        return await axios_requer({
            path: "/admin/v3/tms/carrier/udpateCarrier",
            params,
            hasSing,
        }).then(res => res);
    },
    // 承运商档案-删除承运商
    async delCarrier(params) {
        return await axios_requer({
            path: "/admin/v3/tms/carrier/delCarrier",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 承运商档案-审核
    async examineCarrier(params) {
        return await axios_requer({
            path: "/admin/v3/tms/carrier/examineCarrier",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 承运商档案-返审核
    async reExamineCarrier(params) {
        return await axios_requer({
            path: "/admin/v3/tms/carrier/reExamineCarrier",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 承运商档案-收款账号列表
    async CollecationAccountList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/collecation/account/getCollecationAccountList",
            params,
            method,
        }).then(res => res);
    },
    // 承运商档案-新建收款账号
    async addCollecationAccount(params) {
        return await axios_requer({
            path: "/admin/v3/tms/collecation/account/addCollecationAccount",
            params,
            hasSing
        }).then(res => res);
    },
    // 承运商档案-修改收款账号
    async udpateCollecationAccount(params) {
        return await axios_requer({
            path: "/admin/v3/tms/collecation/account/udpateCollecationAccount",
            params,
            hasSing
        }).then(res => res);
    },
    // 承运商档案-删除收款账号
    async delCollecationAccount(params) {
        return await axios_requer({
            path: "/admin/v3/tms/collecation/account/delCollecationAccount",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 承运商档案-承运商线路列表
    async CarrierLineList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/carrier/getCarrierLineList",
            params,
            method
        }).then(res => res);
    },
    // 承运商档案-新建承运商线路
    async addCarrierLine(params) {
        return await axios_requer({
            path: "/admin/v3/tms/carrier/addCarrierLine",
            params,
            hasSing,
        }).then(res => res);
    },
    // 承运商档案-修改承运商线路
    async udpateCarrierLine(params) {
        return await axios_requer({
            path: "/admin/v3/tms/carrier/udpateCarrierLine",
            params,
            hasSing,
        }).then(res => res);
    },
    // 承运商档案-删除承运商线路
    async delCarrierLine(params) {
        return await axios_requer({
            path: "/admin/v3/tms/carrier/delCarrierLine",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 承运商档案-承运商网点列表
    async CarrierDeptList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/carrier/getCarrierDeptList",
            params,
            method
        }).then(res => res);
    },
    // 承运商档案-新建承运商网点
    async addCarrierDept(params) {
        return await axios_requer({
            path: "/admin/v3/tms/carrier/addCarrierDept",
            params,
            hasSing,
        }).then(res => res);
    },
    // 承运商档案-修改承运商网点
    async udpateCarrierDept(params) {
        return await axios_requer({
            path: "/admin/v3/tms/carrier/udpateCarrierDept",
            params,
            hasSing,
        }).then(res => res);
    },
    // 承运商档案-删除承运商网点
    async delCarrierDept(params) {
        return await axios_requer({
            path: "/admin/v3/tms/carrier/delCarrierDept",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 承运商档案-账号下拉列表
    async AccountDownList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/account/getAccountDownList",
            params,
            method
        }).then(res => res);
    },
    // 收-发货人列表
    async PersonnelList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/customer/getPersonnelList",
            params,
            method
        }).then(res => res);
    },
    // 人员地址列表
    async PersonnelAddrList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/customer/getPersonnelAddrList",
            params,
            method
        }).then(res => res);
    },
    // 客户档案
    // 客户档案-列表
    async CustomerList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/customer/getCustomerList",
            params,
            method
        }).then(res => res);
    },
    // 客户档案-详情
    async CustomerDetail(params) {
        return await axios_requer({
            path: "/admin/v3/tms/customer/getCustomerDetail",
            params,
            method
        }).then(res => res);
    },
    // 客户档案-删除
    async delCustomer(params) {
        return await axios_requer({
            path: "/admin/v3/tms/customer/delCustomer",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 客户档案-新建
    async addCustomer(params) {
        return await axios_requer({
            path: "/admin/v3/tms/customer/addCustomer",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 客户档案-生产客户编号
    async createNumber(params) {
        return await axios_requer({
            path: "/admin/v3/tms/customer/createNumber",
            params,
            method,
        }).then(res => res);
    },
    // 客户档案-修改
    async udpateCustomer(params) {
        return await axios_requer({
            path: "/admin/v3/tms/customer/udpateCustomer",
            params,
            hasSing,
            headerType,
        }).then(res => res);
    },
    // 客户档案-审核
    async examineCustomer(params) {
        return await axios_requer({
            path: "/admin/v3/tms/customer/examineCustomer",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 客户档案-返审核
    async reExamineCustomer(params) {
        return await axios_requer({
            path: "/admin/v3/tms/customer/reExamineCustomer",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 客户档案-人员管理列表
    async CustomerPersonnelList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/customer/getCustomerPersonnelList",
            params,
            method,
        }).then(res => res);
    },
    // 客户档案-新建人员管理
    async addCustomerPersonnel(params) {
        return await axios_requer({
            path: "/admin/v3/tms/customer/addCustomerPersonnel",
            params,
            hasSing
        }).then(res => res);
    },
    // 客户档案-修改人员管理
    async udpateCustomerPersonnel(params) {
        return await axios_requer({
            path: "/admin/v3/tms/customer/udpateCustomerPersonnel",
            params,
            hasSing
        }).then(res => res);
    },
    // 客户档案-删除人员管理
    async delCustomerPersonnel(params) {
        return await axios_requer({
            path: "/admin/v3/tms/customer/delCustomerPersonnel",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 客户档案-客户地址列表
    async CustomerAddrList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/customer/getCustomerAddrList",
            params,
            method
        }).then(res => res);
    },
    // 客户档案-新建客户地址
    async addCustomerAddr(params) {
        return await axios_requer({
            path: "/admin/v3/tms/customer/addCustomerAddr",
            params,
            hasSing
        }).then(res => res);
    },
    // 客户档案-修改客户地址
    async udpateCustomerAddr(params) {
        return await axios_requer({
            path: "/admin/v3/tms/customer/udpateCustomerAddr",
            params,
            hasSing
        }).then(res => res);
    },
    // 客户档案-删除客户地址
    async delCustomerAddr(params) {
        return await axios_requer({
            path: "/admin/v3/tms/customer/delCustomerAddr",
            params,
            headerType,
            hasSing
        }).then(res => res);
    },

    // 财务核销
    // 财务核销-应付核销总表
    async FinanceOutAllList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/getFinanceOutAllList",
            params,
            method
        }).then(res => res);
    },
    // 财务核销-获取应付核销记录
    async FinanceOutWriteoffRecorList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/getFinanceOutWriteoffRecorList",
            params,
            method
        }).then(res => res);
    },
    // 财务核销-财务反核销
    async financeInUnWriteOff(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/financeInUnWriteOff",
            params,
            hasSing
        }).then(res => res);
    },
    // 财务核销-应付整单核销
    async financeOutWriteOff(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/financeOutWriteOff",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务核销-应付部分核销
    async financeOutPartWriteOff(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/financeOutPartWriteOff",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },

    // 财务核销-应收总表
    async FinanceInAllList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/getFinanceInAllList",
            params,
            method
        }).then(res => res);
    },
    // 财务核销-获取应收核销记录
    async FinanceInWriteoffRecorList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/getFinanceInWriteoffRecorList",
            params,
            method
        }).then(res => res);
    },
    // 财务核销-获取应付核销记录
    async FinanceOutWriteoffRecorList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/getFinanceOutWriteoffRecorList",
            params,
            method
        }).then(res => res);
    },
    // 财务核销-应收整单核销
    async financeInWriteOff(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/financeInWriteOff",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务核销-应收部分核销
    async financeInPartWriteOff(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/financeInPartWriteOff",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务核销-运单应收表
    async WaybillFinanceInList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/getWaybillFinanceInList",
            params,
            method
        }).then(res => res);
    },
    // 财务核销-异常核销列表
    async EexceptionFinanceList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/getEexceptionFinanceList",
            params,
            method
        }).then(res => res);
    },
    // 财务核销-外发单核销列表
    async OutGoingFinanceList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/getOutGoingFinanceList",
            params,
            method
        }).then(res => res);
    },
    // 财务核销-发车单核销列表
    async DispatchFinanceList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/getDispatchFinanceList",
            params,
            method
        }).then(res => res);
    },
    // 财务核销-其他收入核销列表
    async OtherFinanceInList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/getOtherFinanceInList",
            params,
            method
        }).then(res => res);
    },
    // 财务核销-其他支出核销列表
    async OtherFinanceOutList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/getOtherFinanceOutList",
            params,
            method
        }).then(res => res);
    },
    // 财务核销-车辆成本核销列表
    async CarFinanceOutList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/getCarFinanceOutList",
            params,
            method
        }).then(res => res);
    },
    // 财务核销-获取代收货款核销列表
    async AgentAmountFinanceOutList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/getAgentAmountFinanceOutList",
            params,
            headerType
        }).then(res => res);
    },

    // 财务核销-代收货款取消支付
    async agentAmountUnPay(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/agentAmountUnPay",
            params,
            headerType,
            hasSing
        }).then(res => res);
    },

    // 财务核销-代收货款取消收回
    async agentAmountUnWriteOff(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/agentAmountUnWriteOff",
            params,
            headerType,
            hasSing
        }).then(res => res);
    },
    // 财务核销-生成对账单
    async createStatement(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/createStatement",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务核销-修改对账单
    async updateStatement(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/updateStatement",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务核销-获取对账单列表
    async StatementList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/getStatementList",
            params,
            method
        }).then(res => res);
    },
    // 财务核销-一键合计
    async sumStatementFinanceAmount(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/sumStatementFinanceAmount",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务核销-根据对账单id获取财务列表
    async StatementFinanceList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/getStatementFinanceList",
            params,
            method
        }).then(res => res);
    },
    // 财务核销-客户对账
    async customerStatement(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/customerStatement",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务核销-删除对账单
    async delStatement(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/delStatement",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },

    // 财务核销-取消客户对账
    async cancelCustomerStatement(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/cancelCustomerStatement",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },

    // 财务核销-获取对账单核销记录
    async StatementWriteoffRecorList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/getStatementWriteoffRecorList",
            params,
            method,
        }).then(res => res);
    },
    // 财务核销-对账单核销
    async statementWriteOff(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/statementWriteOff",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务核销-对账单核销 批量
    async statementBatchWriteOff(params) {
        return await axios_requer({
            path: "/admin/v3/tms/finance/statementBatchWriteOff",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },

    // 财务核销-资金账号列表
    async assetaccountList(params) {
        return await axios_requer({
            path: "/admin/v3/finance/assetaccount/assetaccountList",
            params,
            method
        }).then(res => res);
    },

    // 财务核销-资金账号详情
    async assetaccountDatail(params) {
        return await axios_requer({
            path: "/admin/v3/finance/assetaccount/assetaccountDatail",
            params,
            method
        }).then(res => res);
    },
    // 财务核销-新增资金账号
    async addAssetaccount(params) {
        return await axios_requer({
            path: "/admin/v3/finance/assetaccount/addAssetaccount",
            params,
            hasSing
        }).then(res => res);
    },
    // 财务核销-修改资金账号
    async updateAssetaccount(params) {
        return await axios_requer({
            path: "/admin/v3/finance/assetaccount/updateAssetaccount",
            params,
            hasSing
        }).then(res => res);
    },
    // 财务核销-资金账号取消申请
    async deleteAssetaccount(params) {
        return await axios_requer({
            path: "/admin/v3/finance/assetaccount/deleteAssetaccount",
            params,
            hasSing,
        }).then(res => res);
    },
    // 财务核销-启用-禁用资金账号
    async handleIsShow(params) {
        return await axios_requer({
            path: "/admin/v3/finance/assetaccount/handleIsShow",
            params,
            hasSing
        }).then(res => res);
    },

    // 财务核销-获取资金调拨列表
    async AllocationRecordListV2(params) {
        return await axios_requer({
            path: "/admin/v3/finance/allocation/record/getAllocationRecordListV2",
            params,
            method
        }).then(res => res);
    },
    // 财务核销-新增资金调拨
    async addAllocationRecordV2(params) {
        return await axios_requer({
            path: "/admin/v3/finance/allocation/record/addAllocationRecordV2",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务核销-删除资金调拨
    async deleteRecordV2(params) {
        return await axios_requer({
            path: "/admin/v3/finance/allocation/record/deleteRecordV2",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务核销-取消转出
    async cancelOutV2(params) {
        return await axios_requer({
            path: "/admin/v3/finance/allocation/record/cancelOutV2",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务核销-转出确认
    async outSureV2(params) {
        return await axios_requer({
            path: "/admin/v3/finance/allocation/record/outSureV2",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务核销-转入确认
    async inSureV2(params) {
        return await axios_requer({
            path: "/admin/v3/finance/allocation/record/inSureV2",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },

    // 财务核销-资金流水账列表
    async journalAccountList(params) {
        return await axios_requer({
            path: "/admin/v3/finance/assetaccount/journalAccountList",
            params,
            headerType
        }).then(res => res);
    },
    // 财务核销-对账操作(取消对账&对账)
    async cancelReconciliation(params) {
        return await axios_requer({
            path: "/admin/v3/finance/assetaccount/cancelReconciliation",
            params,
            hasSing
        }).then(res => res);
    },

    // 财务核销-费项设置/费型列表
    async itemServiceList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/itemservice/itemServiceList",
            params,
            method
        }).then(res => res);
    },

    // 财务核销-费项设置/费型类型下拉列表
    async itemCategorChoose(params) {
        return await axios_requer({
            path: "/admin/v3/tms/itemservice/itemCategorChoose",
            params,
            method
        }).then(res => res);
    },
    // 财务核销-费项设置/根据类别和费项类型获取费项
    async CategoryServiceList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/itemservice/getCategoryServiceList",
            params,
            method
        }).then(res => res);
    },
    // 财务核销-费项设置/新增费项
    async addItemService(params) {
        return await axios_requer({
            path: "/admin/v3/tms/itemservice/addItemService",
            params,
            hasSing,
        }).then(res => res);
    },
    // 财务核销-费项设置/修改费项
    async updateItemService(params) {
        return await axios_requer({
            path: "/admin/v3/tms/itemservice/updateItemService",
            params,
            hasSing,
        }).then(res => res);
    },
    // 财务核销-费项设置/禁用费项
    async stopItemService(params) {
        return await axios_requer({
            path: "/admin/v3/tms/itemservice/stopItemService",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务核销-费项设置/启用费项
    async startItemService(params) {
        return await axios_requer({
            path: "/admin/v3/tms/itemservice/startItemService",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务核销-费项类型维护/费型类型左侧列表
    async itemCategorLeftList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/itemservice/itemCategorLeftList",
            params,
            method
        }).then(res => res);
    },
    // 财务核销-启用费项类型
    async startItemCategory(params) {
        return await axios_requer({
            path: "/admin/v3/tms/itemservice/startItemCategory",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务核销-禁用费项类型
    async stopItemCategory(params) {
        return await axios_requer({
            path: "/admin/v3/tms/itemservice/stopItemCategory",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务核销-删除费项类型
    async delItemCategory(params) {
        return await axios_requer({
            path: "/admin/v3/tms/itemservice/delItemCategory",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务核销-费项类型维护/费型类型右侧列表
    async itemCategoryList(params) {
        return await axios_requer({
            path: "/admin/v3/tms/itemservice/itemCategoryList",
            params,
            method
        }).then(res => res);
    },
    // 财务核销-费项类型维护/新增费项类型
    async addItemCategory(params) {
        return await axios_requer({
            path: "/admin/v3/tms/itemservice/addItemCategory",
            params,
            hasSing
        }).then(res => res);
    },
    // 财务核销-删除费项
    async delItemService(params) {
        return await axios_requer({
            path: "/admin/v3/tms/itemservice/delItemService",
            params,
            hasSing,
            headerType
        }).then(res => res);
    },
    // 财务核销-费项类型维护/修改费项类型
    async updateItemCategor(params) {
        return await axios_requer({
            path: "/admin/v3/tms/itemservice/updateItemCategor",
            params,
            hasSing
        }).then(res => res);
    },

    // 发票管理-获取发票列表
    async InvoiceList(params) {
        return await axios_requer({
            path: "/admin/v3/finance/invoice/getInvoiceList",
            params,
            method
        }).then(res => res);
    },
    // 发票管理-获取发票详情
    async InvoiceDetail(params) {
        return await axios_requer({
            path: "/admin/v3/finance/invoice/getInvoiceDetail",
            params,
            method
        }).then(res => res);
    },
    // 发票管理-根据发票id获取财务列表
    async InvoiceFinanceList(params) {
        return await axios_requer({
            path: "/admin/v3/finance/invoice/getInvoiceFinanceList",
            params,
            method
        }).then(res => res);
    },
    // 发票管理-新建发票
    async addInvoice(params) {
        return await axios_requer({
            path: "/admin/v3/finance/invoice/addInvoice",
            params,
            hasSing,
        }).then(res => res);
    },
    // 发票管理-修改发票-开票确认
    async updateInvoice(params) {
        return await axios_requer({
            path: "/admin/v3/finance/invoice/updateInvoice",
            params,
            hasSing,
        }).then(res => res);
    },
    // 发票管理-取消确认
    async cancelInvoiceSure(params) {
        return await axios_requer({
            path: "/admin/v3/finance/invoice/cancelInvoiceSure",
            params,
            headerType,
            hasSing
        }).then(res => res);
    },
    // 发票管理-删除发票
    async delInvoice(params) {
        return await axios_requer({
            path: "/admin/v3/finance/invoice/delInvoice",
            params,
            headerType,
            hasSing
        }).then(res => res);
    },

    // 车辆详情
    async getCarDetail(params) {
        return await axios_requer({
            path: "/admin/v3/tms/car/getCarDetail",
            params,
            method
        }).then(res => res);
    },


}